export default "/images/vendor/flag-icon-css/flags/4x3/ph.svg?596b9b66d026fa222c2d4a055e7f299d";